/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { useFacilityAlerts } from 'sarsaparilla';
import { FacilityAlertBanner } from 'shared-ui/components/FacilityAlertBanner/FacilityAlertBanner';

export default function Banner() {
    const alerts = useFacilityAlerts();

    return <FacilityAlertBanner alerts={alerts} />;
}
